import { BUILD_VERSION } from '@ds/core';

export const environment = {
  build: BUILD_VERSION,
  production: true,
  fileStackPublicKey: 'AvLVW6vvuTjCqG5oZVY5Cz',
  loginUrl: '/login',
};
